"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionStore = void 0;
exports.dispatchable = dispatchable;

var _stringCaseUtils = _interopRequireDefault(require("../util/stringCaseUtils"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _functionsIn = _interopRequireDefault(require("lodash/functionsIn"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _mobx = require("mobx");

var _clientErrorLogger = _interopRequireDefault(require("../util/clientErrorLogger"));

var _toUpper = _interopRequireDefault(require("lodash/toUpper"));

var _class;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

var constantName = function constantName(str) {
  return (0, _toUpper.default)(_stringCaseUtils.default.camelCaseToSnakeCase(str));
}; // "dispatchable" is a total lie. we are simply making the function enumerable so that events() can pick it up through functionsIn


function dispatchable(target, functionName, descriptor) {
  descriptor.enumerable = true;
  return descriptor;
}

var ActionStore = (_class = /*#__PURE__*/function () {
  function ActionStore(dispatcher) {
    _classCallCheck(this, ActionStore);

    this.dispatcher = dispatcher;
    this._registeredModals = {};
    this.logger = _clientErrorLogger.default; // cheap debugging trick

    if (typeof window !== "undefined") {
      window["__" + this.constructor.name] = this;
    }
  } // register all functions that we can enumerate


  _createClass(ActionStore, [{
    key: "events",
    value: function events() {
      var _this = this;

      var eventRegistry = {};
      (0, _forEach.default)((0, _functionsIn.default)(this), function (functionName) {
        eventRegistry[constantName(functionName)] = (0, _mobx.action)(_this[functionName]);
      });
      return eventRegistry;
    }
  }, {
    key: "onBind",
    value: function onBind(dispatcher) {
      this.dispatcher = dispatcher;
    }
  }, {
    key: "registerModals",
    value: function registerModals(modalArray) {
      var _this2 = this;

      (0, _forEach.default)(modalArray, function (m) {
        _this2._registeredModals[m.modalKey] = m;
      });
    }
  }, {
    key: "openModal",
    value: function openModal(e) {
      if (!(0, _isUndefined.default)(this._registeredModals[e.data.modalKey])) {
        // pass dispatcher for async endpoint modals
        this._registeredModals[e.data.modalKey].open(e.data.dispatcher);
      }
    }
  }, {
    key: "hideModal",
    value: function hideModal(e) {
      if (!(0, _isUndefined.default)(this._registeredModals[e.data.modalKey])) {
        this._registeredModals[e.data.modalKey].close();
      }
    }
  }]);

  return ActionStore;
}(), (_applyDecoratedDescriptor(_class.prototype, "openModal", [dispatchable], Object.getOwnPropertyDescriptor(_class.prototype, "openModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideModal", [dispatchable], Object.getOwnPropertyDescriptor(_class.prototype, "hideModal"), _class.prototype)), _class);
exports.ActionStore = ActionStore;